import { CompaniesAppWebComponent } from './component/CompaniesAppWebComponent';
import { WEB_COMPONENT_COMPANIES_APP } from '../../webcomponents.constants';

export { CompaniesAppWebComponent };

window.customElements.define(WEB_COMPONENT_COMPANIES_APP, CompaniesAppWebComponent);
